module.exports = __webpack_public_path__ + "img/msteams-icon.e81c7361.svg";